import merge from 'lodash/merge';
import defaultConfig from '@/config/default-config.json';

/* eslint-disable no-unused-vars, no-param-reassign */

const initialState = {
  environment: process.env.NODE_ENV,
  config: {
    navigation: {
      show: true,
    },
    footer: {
      height: '50',
      text: '© Copyright {currentYear} Morningstar, Inc. All rights reserved.',
      show: true,
    },
    isInternalProcessLayout: false,
    investmentReports: {
      availableFiduciaries: [],
    },
  },
  isLoading: false,
  errors: [],
};

const actions = {
  setConfig: {
    root: true,
    handler({ commit }, clientCode = '') {
      commit('setConfig', clientCode);
    },
  },
  overrideConfig: {
    root: true,
    handler({ commit }, newConfig = {}) {
      commit('overrideConfig', newConfig);
    },
  },
  clearConfig: {
    root: true,
    handler({ commit }) {
      commit('clearConfig');
    },
  },
  setIsLoading: {
    root: true,
    handler({ commit }, isLoading) {
      commit('setIsLoading', isLoading);
    },
  },
  setIsInternalProcessLayout: {
    root: true,
    handler({ commit }, isInternalProcessLayout) {
      commit('setIsInternalProcessLayout', isInternalProcessLayout);
    },
  },
  showNavigationBar: {
    root: true,
    handler({ commit }) {
      commit('showNavigationBar');
    },
  },
  hideNavigationBar: {
    root: true,
    handler({ commit }) {
      commit('hideNavigationBar');
    },
  },
  logError: {
    root: true,
    handler({ commit }, error) {
      commit('logError', error);
    },
  },
};

const mutations = {
  setConfig(state, clientCode) {
    const clientConfig = defaultConfig[clientCode] || {};
    state.config = merge({}, defaultConfig.global, clientConfig);
  },
  showNavigationBar(state) {
    state.config.navigation.show = true;
  },
  hideNavigationBar(state) {
    state.config.navigation.show = false;
  },
  overrideConfig(state, newConfig) {
    state.config = merge(state.config, newConfig);
  },
  clearConfig(state) {
    state.config = {
      footer: {
        height: '50',
        text: '© Copyright {currentYear} Morningstar, Inc. All rights reserved.',
      },
    };
  },
  clearUserInfo(state) {
    state = {};
  },
  setIsLoading(state, isLoading) {
    state.isLoading = !!isLoading;
  },
  setIsInternalProcessLayout(state, isInternalProcessLayout) {
    state.config.isInternalProcessLayout = isInternalProcessLayout;
  },
  logError(state, newError) {
    state.errors.unshift({
      when: new Date(),
      ...newError,
    });
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
